import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActivitySegmentNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M12 23.439L5.449 11.1a7.232 7.232 0 011.308-8.63 7.49 7.49 0 0110.486 0 7.232 7.232 0 011.307 8.63L12 23.439zm0-21.762a6.093 6.093 0 00-4.294 1.754 5.891 5.891 0 00-1.066 7.034L12 20.561l5.36-10.1a5.892 5.892 0 00-1.066-7.034A6.094 6.094 0 0012 1.677z"
        fill=""
      />
    </svg>
  )
);
SvgActivitySegmentNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgActivitySegmentNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActivitySegmentNormalSmall;
